import * as Yup from "yup";

const supplierValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  companyName: Yup.string().nullable().default(null),
  phoneNumbers: Yup.array()
    .of(
      Yup.string()
        .trim()
        .min(9, "Phone number must be at least 9 characters")
        .max(15, "Phone number must be at most 15 characters")
        .matches(/^[0-9]{9,15}$/, "Phone number must be a valid phone number")
        .required("Phone number is required")
        .test("unique", "Phone numbers must be unique", function (value) {
          if (!value || !this.parent) return true;
          const count = this.parent.filter((v) => v === value).length;
          return count <= 1;
        })
    )
    .min(1, "At least one phone number is required")
    .required("Phone number is required"),
  bankDetails: Yup.array()
    .of(
      Yup.object().shape({
        accountNumber: Yup.string()
          .trim()
          .required("Account number is required"),
        bankName: Yup.string().trim().required("Bank name is required"),
        accountOwnerName: Yup.string()
          .trim()
          .required("Account owner name is required"),
        branch: Yup.string().trim().required("Branch is required"),
      })
    )
    .min(1, "At least one bank account is required")
    .required("At least one bank account is required"),
});

const supplierUpdateValidationSchema = Yup.object().shape({
  name: Yup.string().trim(),
  companyName: Yup.string().nullable(),
});

const addBankDetailsValidationSchema = Yup.object().shape({
  bankDetails: Yup.array()
    .of(
      Yup.object().shape({
        accountNumber: Yup.string()
          .trim()
          .required("Account number is required"),
        bankName: Yup.string().trim().required("Bank name is required"),
        accountOwnerName: Yup.string()
          .trim()
          .required("Account owner name is required"),
        branch: Yup.string().trim().required("Branch is required"),
      })
    )
    .min(1, "At least one bank account is required")
    .required("At least one bank account is required"),
});

const updateBankDetailsValidationSchema = Yup.object().shape({
  accountNumber: Yup.string().trim().required("Account number is required"),
  bankName: Yup.string().trim().required("Bank name is required"),
  accountOwnerName: Yup.string()
    .trim()
    .required("Account owner name is required"),
  branch: Yup.string().trim().required("Branch is required"),
});

const addPhoneNumbersValidationSchema = Yup.object().shape({
  phoneNumbers: Yup.array()
    .of(
      Yup.string()
        .trim()
        .min(9, "Phone number must be at least 9 characters")
        .max(15, "Phone number must be at most 15 characters")
        .matches(/^[0-9]{9,15}$/, "Phone number must be a valid phone number")
        .required("Phone number is required")
    )
    .min(1, "At least one phone number is required")
    .required("At least one phone number is required")
    .test("unique", "Phone numbers must be unique", (values) => {
      if (!values || values.length === 0) return true;
      return new Set(values).size === values.length;
    }),
});

const updatePhoneNumberValidationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .trim()
    .min(9, "Phone number must be at least 9 characters")
    .max(15, "Phone number must be at most 15 characters")
    .matches(/^[0-9]{9,15}$/, "Phone number must be a valid phone number")
    .required("Phone number is required"),
});

export {
  supplierValidationSchema,
  supplierUpdateValidationSchema,
  addBankDetailsValidationSchema,
  updateBankDetailsValidationSchema,
  addPhoneNumbersValidationSchema,
  updatePhoneNumberValidationSchema,
};
